import React from 'react';
import { motion } from 'framer-motion';
import { Users, Download, Code2, Activity } from 'lucide-react';
import { cn } from '../../../lib/utils';

const stats = [
  {
    icon: Users,
    value: '24M+',
    label: 'Visitors engaged through seamless tech at Expo 2020 Dubai',
    color: 'from-blue-500/20 to-transparent'
  },
  {
    icon: Download,
    value: '2M+',
    label: 'Mobile App Downloads, enhancing user interactions',
    color: 'from-purple-500/20 to-transparent'
  },
  {
    icon: Code2,
    value: '100+',
    label: 'Cutting-Edge Applications developed',
    color: 'from-green-500/20 to-transparent'
  },
  {
    icon: Activity,
    value: '100M+',
    label: 'User Interactions, delivering intuitive experiences',
    color: 'from-orange-500/20 to-transparent'
  }
];

const OurImpact = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-black to-accent/5 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-display font-semibold text-white mb-12"
        >
          Our Impact in Numbers
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={cn(
                  "relative p-8 rounded-xl",
                  "bg-gradient-to-br from-white/5 to-transparent",
                  "border border-white/10 hover:border-accent/50",
                  "transition-all duration-300 group"
                )}
              >
                <div className="relative">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors duration-300">
                      <Icon className="w-6 h-6 text-accent" />
                    </div>
                  </div>
                  <h3 className="text-5xl font-display font-bold text-white mb-4">
                    {stat.value}
                  </h3>
                  <p className="text-lg text-gray-300">
                    {stat.label}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurImpact;